export default __webpack_public_path__ + "static/BAP_4328-Verbessert-NR_rgb_fine-858f840994862a84c1d76070d38f1678.jpg";